'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactRouter = require('react-router');
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);

var _index = require('../../index');
var _OMBasePropertyCell = require('../OMPropertyCells/OMBasePropertyCell/OMBasePropertyCell');var _OMBasePropertyCell2 = _interopRequireDefault(_OMBasePropertyCell);


var _makeSharingUrl = require('../../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _formatSEOData = require('../../../utils/formatSEOData');
var _controlButtonsConfig = require('../../../pages/ManagePropertiesPage/controlButtonsConfig');var _controlButtonsConfig2 = _interopRequireDefault(_controlButtonsConfig);

var _checkIsForeignAddress = require('../../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);
var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _getIconStatus = require('../../../utils/getIconStatus');
var _analyticsManager = require('../../../utils/analytics/analyticsManager');
var _parkingConverter = require('../../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);

var _OMRegularManageCellMobile = require('./OMRegularManageCellMobile.scss');var styles = _interopRequireWildcard(_OMRegularManageCellMobile);
var _formatTimeFromDate = require('../../../helpers/formatTimeFromDate');var _formatTimeFromDate2 = _interopRequireDefault(_formatTimeFromDate);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var OMRegularManageCellMobile = function (_Component) {_inherits(OMRegularManageCellMobile, _Component);function OMRegularManageCellMobile() {var _temp, _this, _ret;_classCallCheck(this, OMRegularManageCellMobile);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.formatShareData = function () {var _this$props =
      _this.props,_this$props$property = _this$props.property,thumbnail = _this$props$property.thumbnail,id = _this$props$property.id,locale = _this$props.locale,translate = _this$props.translate;
      var sharingUrl = (0, _makeSharingUrl2.default)('/home_details/' + id, locale);
      var propertyType = _this.props.translate('propertyTypes', _this.props.property.property_type)();

      var sharingTitle = (0, _formatSEOData.formatPropertyTitle)(
      _this.props.property,
      propertyType,
      translate('propertyDetails'),
      locale);

      return {
        sharingUrl: sharingUrl,
        sharingTitle: sharingTitle,
        thumbnail: thumbnail };

    }, _this.

    handleEdit = function (event) {
      event.stopPropagation();
      _this.props.editProperty(_this.props.id);
      setTimeout(function () {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/property/edit?id=' + _this.props.id));
      });
    }, _this.

    handleSecondJump = function () {
      _this.props.openJumpToTopModal();
    }, _this.

    handleUpgradePackage = function () {
      _this.props.openUpgradePackageModal(_this.props.id);
    }, _this.

    toggleActivity = function () {return !_this.props.suspended && _this.props.updatePropertyActivity({
        properties: [_this.props.property],
        active: !_this.props.isActive });}, _this.


    openDetailsPopup = function () {
      _this.props.openDetailsPopup(_this.generatePreloadData());
      (0, _analyticsManager.trackModalOpen)('property/' + _this.props.id);
    }, _this.

    generatePreloadData = function () {return {
        propertyId: _this.props.id,
        address: _this.props.addressData,
        price: _this.props.price,
        additionalInfo: {
          area: _this.props.area,
          floor: _this.props.floor === 0 ? _this.props.groundFloorTitle.toString() : _this.props.floor,
          parkingSpots: (0, _parkingConverter2.default)(_this.props.parkingSpots),
          rooms: _this.props.rooms },

        propertyType: _this.props.propertyType,
        optionType: _this.props.optionType };}, _this.


    clickHandlers = {
      handleEdit: _this.handleEdit,
      handleSecondJump: _this.handleSecondJump,
      openDetailsPopup: _this.openDetailsPopup,
      toggleActivity: _this.toggleActivity,
      upgradePackage: _this.handleUpgradePackage }, _this.


    toggleAutoJumpActivity = function () {var _this$props$property2 =

      _this.props.property,id = _this$props$property2.id,isActive = _this$props$property2.is_active,isSuspended = _this$props$property2.is_suspended,autoJumpEnabled = _this$props$property2.is_autojump_enabled;

      if (isActive && !isSuspended && !_this.props.disabledPromotionAction) {
        _this.props.updateAutoJumpToTopActivity({
          ids: [id],
          enable: !autoJumpEnabled });

      }
    }, _this.

    toggleHighlight = function () {var _this$props$property3 =

      _this.props.property,id = _this$props$property3.id,isPromoted = _this$props$property3.is_promoted,isActive = _this$props$property3.is_active,isSuspended = _this$props$property3.is_suspended;

      if (isActive && !isSuspended && !_this.props.disabledPromotionAction) {
        _this.props.updatePropertyHighlighting({
          ids: [id],
          promote: !isPromoted });

      }
    }, _this.
    toggleTopPromotion = function () {var _this$props$property4 =
      _this.props.property,id = _this$props$property4.id,is_top_promoted = _this$props$property4.is_top_promoted,is_active = _this$props$property4.is_active,is_suspended = _this$props$property4.is_suspended,thumbnail = _this$props$property4.thumbnail;

      if (thumbnail && is_active && !is_suspended && !_this.props.disabledPromotionAction) {
        _this.props.updateTopPromotionActivity({
          ids: [id],
          promote: !is_top_promoted });

      } else {
        _this.props.openMessageModal({ message:
          _react2.default.createElement('div', null, _this.props.translate('managePage', 'requiredPromotionTopDescription')) });

      }
    }, _this.

    renderControlButton = function (_ref) {var _ref$props = _ref.props,className = _ref$props.className,restProps = _objectWithoutProperties(_ref$props, ['className']),icon = _ref.icon,title = _ref.title;return (
        _react2.default.createElement('button', _extends({
            className: (0, _classnames2.default)(styles.controlButton, className) },
          restProps),

          _react2.default.createElement('i', { className: 'icon icon-' + icon },
            _react2.default.createElement('i', { className: 'path1' }),
            _react2.default.createElement('i', { className: 'path2' }),
            _react2.default.createElement('i', { className: 'path3' }),
            _react2.default.createElement('i', { className: 'path4' }),
            _react2.default.createElement('i', { className: 'path5' }),
            _react2.default.createElement('i', { className: 'path6' }),
            _react2.default.createElement('i', { className: 'path7' })),

          !_this.props.isMobile && _react2.default.createElement('br', null),
          _react2.default.createElement('span', null, title)));}, _this.



    renderAutoJumpDataTitle = function () {var
      manualJumpDate = _this.props.property.manual_jump_date;

      if (!!manualJumpDate) {
        return '\n        ' +
        _this.props.jumpToTopTooltipText + '\n        ' +
        _this.props.translate('managePage', 'manualJumpDate') + '\n        ' +
        (0, _formatTimeFromDate2.default)(manualJumpDate) + '\n      ';

      }

      return _this.props.jumpToTopTooltipText;
    }, _this.

    renderControlButtons = function () {
      if (!_this.props.editable) {
        return null;
      }var _this$props2 =

      _this.props,isActive = _this$props2.isActive,jumpToTopTooltipText = _this$props2.jumpToTopTooltipText,canSecondJump = _this$props2.canSecondJump;

      var buttonsConfig = (0, _controlButtonsConfig2.default)(_this.props, _this.clickHandlers);
      var isForeignProperty = (0, _checkIsForeignAddress2.default)(_this.props.addressData);

      var mobileControls =
      _react2.default.createElement('div', null,
        _react2.default.createElement('div', { className: styles.btnWr },
          !isForeignProperty && _this.renderControlButton(buttonsConfig.upgradePackage),
          _this.renderControlButton(buttonsConfig.activity)),

        !isForeignProperty &&
        _react2.default.createElement('div', { className: styles.moveToTopButtonWrap },
          _react2.default.createElement('div', { className: styles.moveToTopButton },
            _this.renderControlButton(buttonsConfig.jumpToTop),
            canSecondJump && _this.renderControlButton(buttonsConfig.secondJumpToTop)),

          isActive && _react2.default.createElement('div', { className: styles.moveToTopTooltip }, _this.renderAutoJumpDataTitle(), ' ')));





      return (
        _react2.default.createElement('div', { className: styles.propertyDesc, ref: _this.createControlButtonsRef },
          mobileControls));


    }, _this.

    renderPropertyViews = function () {var _this$props3 =
      _this.props,propertyViews = _this$props3.propertyViews,propertyViewsText = _this$props3.propertyViewsText,propertyNumber = _this$props3.propertyNumber,propertyFavorites = _this$props3.propertyFavorites;
      if (!_this.props.editable) {
        return null;
      }

      var isForeign = (0, _checkIsForeignAddress2.default)(_this.props.addressData);
      var phoneClicksCount = propertyNumber || (0, _get2.default)(_this.props, 'property.phone_clicks_count', 0);
      var favouritesCount = propertyFavorites || (0, _get2.default)(_this.props, 'property.favourites_count', 0);

      var viewsIcon =
      _react2.default.createElement('i', { className: 'icon icon-eye' },
        _react2.default.createElement('span', { className: 'path1' }),
        _react2.default.createElement('span', { className: 'path2' }));


      var viewsCount = propertyViews || 0;

      var buttonContent = [
      { id: 1, value: viewsIcon },
      { id: 2, value: propertyViewsText },
      { id: 3, value: viewsCount }];


      return (
        _react2.default.createElement('div', { className: styles.propertyInformationWrapper },
          _react2.default.createElement('div', { className: styles.propertyViews, onClick: _this.showViewsChart },
            buttonContent.map(function (item) {return _react2.default.createElement('span', { key: item.id }, item.value);})),

          !isForeign &&
          _react2.default.createElement('div', { className: styles.phoneClicksCount },
            _react2.default.createElement('i', { className: 'icon icon-phone' }), '\xA0\xA0',
            _react2.default.createElement('span', null, phoneClicksCount)),


          _react2.default.createElement('div', { className: styles.favouritesCount },
            _react2.default.createElement('i', { className: 'icon icon-favorite' }), '\xA0\xA0',
            _react2.default.createElement('span', null, favouritesCount))));



    }, _this.

    renderPromotions = function () {
      var isForeign = (0, _checkIsForeignAddress2.default)(_this.props.addressData);

      if (!_this.props.editable || isForeign) {
        return null;
      }var _this$props4 =

      _this.props,autoJumpEnabled = _this$props4.autoJumpEnabled,promoted = _this$props4.promoted,isTopPromotedProperty = _this$props4.isTopPromotedProperty,isCanManagePromotions = _this$props4.isCanManagePromotions;
      var autoJumpStatus = autoJumpEnabled ? 'Active' : 'Disabled';
      var promotionStatus = promoted ? 'Active' : 'Disabled';
      var topPromotionStatus = isTopPromotedProperty ? 'Active' : 'Disabled';

      var topPromotion = (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.top_promotion', null);
      var highlight = (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.promotion', null);
      var autoJump = (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.jump_promotion', null);

      var promotionUntilTopPromotion = topPromotion.until && (0, _moment2.default)(topPromotion.until);
      var promotionUntilTopPromotionFormatted = promotionUntilTopPromotion && promotionUntilTopPromotion.utc().format('DD/MM/YYYY') || '-';

      var promotionUntilHighlight = highlight.until && (0, _moment2.default)(highlight.until);
      var promotionUntilHighlightFormatted = promotionUntilHighlight && promotionUntilHighlight.utc().format('DD/MM/YYYY') || '-';

      var promotionUntilAutoJump = autoJump.until && (0, _moment2.default)(autoJump.until);
      var promotionUntilAutoJumpFormatted = promotionUntilAutoJump && promotionUntilAutoJump.utc().format('DD/MM/YYYY') || '-';


      return (
        _react2.default.createElement('div', { className: styles.promotionsBlock },
          _react2.default.createElement('span', { className: styles.promotionsTitle }, _this.props.translate('managePage', 'promotionsTitle'), ':'),
          _react2.default.createElement('div', null,
            _react2.default.createElement('i', {
                onClick: isCanManagePromotions && _this.toggleTopPromotion,
                'data-title': _this.props.translate('topPromotion' + topPromotionStatus + 'RegularUserTitle').replace('___', String.fromCharCode(8207) + 'TOP'),
                className: (0, _classnames2.default)('icon icon-top-promotion' +
                (0, _getIconStatus.addEnding)(topPromotionStatus.toLocaleLowerCase())) },


              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' })),

            topPromotionStatus === 'Active' ? promotionUntilTopPromotionFormatted : ''),

          _react2.default.createElement('div', null,
            _react2.default.createElement('i', {
                onClick: isCanManagePromotions && _this.toggleHighlight,
                'data-title': _this.props.translate('highlight' + promotionStatus + 'RegularUserTitle'),
                className: (0, _classnames2.default)('icon icon-promoted' +
                (0, _getIconStatus.addEnding)(promotionStatus.toLocaleLowerCase())) },


              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' })),

            promotionStatus === 'Active' ? promotionUntilHighlightFormatted : '')));















    }, _this.

    renderInactiveOverlay = function () {
      if (_this.props.isActive || !_this.props.editable) {
        return null;
      }

      return (
        _react2.default.createElement('div', { className: styles.inactiveOverlay }));

    }, _temp), _possibleConstructorReturn(_this, _ret);}OMRegularManageCellMobile.prototype.

  render = function render() {var
    translate = this.props.translate;
    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        _react2.default.createElement(_OMBasePropertyCell2.default, _extends({
          classNameProperty: 'propertiesListMobile',
          onHandlerEdit: this.handleEdit,
          onOpenDetails: this.clickHandlers.openDetailsPopup,
          active: this.props.isActive,
          showManagePropertiesPack: true },
        this.props, {
          propertyType: this.props.editable ? this.props.optionAndPropertyTypes : this.props.propertyType })),

        this.renderPromotions(),
        this.renderPropertyViews(),
        _react2.default.createElement(_index.ShareBlock, {
          locale: this.props.locale,
          translate: translate,
          sharingData: this.formatShareData(),
          copyLinkTitle: '' + translate('copyLink'),
          emailTitle: '' + translate('propertyDetails', 'contacts', 'email'),
          className: 'sharePropertiesMobileBlock',
          sizeIcon: 24,
          iconFill: true }),

        this.renderControlButtons(),
        this.renderInactiveOverlay()));


  };return OMRegularManageCellMobile;}(_react.Component);


OMRegularManageCellMobile.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  propertyType: _propTypes2.default.string,
  optionAndPropertyTypes: _propTypes2.default.string,
  photo: _propTypes2.default.string,
  price: _propTypes2.default.number,
  address: _propTypes2.default.string,
  rooms: _propTypes2.default.number,
  parkingSpots: _propTypes2.default.object,
  city: _propTypes2.default.string,
  area: _propTypes2.default.number,
  floor: _propTypes2.default.number,
  isFavorite: _propTypes2.default.bool,
  isNewProperty: _propTypes2.default.bool,
  hasVRLink: _propTypes2.default.bool,
  propertyNote: _propTypes2.default.string,
  parkingIconTitle: _propTypes2.default.func,
  roomsIconTitle: _propTypes2.default.func,
  editProperty: _propTypes2.default.func,
  propertyViewsText: _propTypes2.default.func,
  property: _propTypes2.default.object,
  floorIconTitle: _propTypes2.default.func,
  squareIconTitle: _propTypes2.default.func,
  groundFloorTitle: _propTypes2.default.func,
  openUpgradePackageModal: _propTypes2.default.func,
  addPropertyNote: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  searchOption: _propTypes2.default.string,
  propertyViews: _propTypes2.default.number,
  createdAt: _propTypes2.default.string,
  loadSinglePropertyAnalytics: _propTypes2.default.func,
  openChartOfViews: _propTypes2.default.func,
  editable: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  openJumpToTopModal: _propTypes2.default.func,
  optionType: _propTypes2.default.string,
  isActive: _propTypes2.default.bool,
  openDetailsPopup: _propTypes2.default.func,
  copyLinkText: _propTypes2.default.func,
  canSecondJump: _propTypes2.default.bool,
  openModalShare: _propTypes2.default.func,
  suspended: _propTypes2.default.bool,
  jumpToTopTooltipText: _propTypes2.default.func,
  updatePropertyActivity: _propTypes2.default.func,
  addressData: _propTypes2.default.object,
  promoted: _propTypes2.default.bool,
  autoJumpEnabled: _propTypes2.default.bool,
  isTopPromotedProperty: _propTypes2.default.bool,
  userProperties: _propTypes2.default.object,
  updateAutoJumpToTopActivity: _propTypes2.default.func,
  updatePropertyHighlighting: _propTypes2.default.func,
  updateTopPromotionActivity: _propTypes2.default.func,
  disabledPromotionAction: _propTypes2.default.bool,
  isCanManagePromotions: _propTypes2.default.bool,
  openMessageModal: _propTypes2.default.func,
  propertyNumber: _propTypes2.default.number,
  propertyFavorites: _propTypes2.default.number };exports.default =


OMRegularManageCellMobile;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMRegularManageCellMobile/OMRegularManageCellMobile.js
// module id = 2773
// module chunks = 0